import chalk from 'chalk'

const termChalk = new chalk.Instance({enabled: true, level: 2})
const regIP = /((\b\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*\b)|(\b\s*((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*\b))/igm
const regIndex = /\[[\d:]+\]/gm
const regCLIArg = /\s((-[\d\w]+\b)|(--[\d\w\-.]*))/gm
const regCLIVar = /\s\$(({[\w]+})|[\w]+\b)/gm

function words2regex(words) {
    let regStr = ""
    words.forEach((w) => { regStr += (regStr === "" ?  `(\\b${w}\\b)` : `|(\\b${w}\\b)`) })
    return new RegExp(`${regStr}`, "igm")
}

class Rule {
    colorRules = []

    constructor(colorRules) {
        this.colorRules = colorRules
    }

    render(str) {
        let renderedString = str
        for (let cr of this.colorRules) {
            for (let reg of cr.regexList) {
                renderedString = renderedString.replaceAll(reg, function(match) { 
                    return cr.render(match)})
            }
        }
        return renderedString
    }
}

let terminalColorRules = [
    {
        regexList: [regIP, words2regex(["none", "return"])],
        render: termChalk.magenta
    },
    {
        regexList: [words2regex(["yes", "accepted", "accept", "success", "passed", "session opened"])],
        render: termChalk.green
    },
    {
        regexList: [regIndex, regCLIArg, words2regex(["information", "info" , "ip address", "Last login"])],
        render: termChalk.blue
    },
    {
        regexList: [regCLIVar, words2regex(["stopped", "disconnect", "unknown"])],
        render: termChalk.yellow
    },
    {
        regexList: [words2regex(["drop", "no", "failed", "failure", "error", "errors", "corrupted", "connection refused"])],
        render: termChalk.red
    },
]

let terminalHighlightRender = new Rule(terminalColorRules)

// class Render
function terminalHighlight(str) {
    return terminalHighlightRender.render(str)
}

export default {
    terminalHighlight,
}